/** Static map decor packed into decor-atlas.webp (tools/atlas/build-decor-atlas.mjs). */
export const DECOR_STATIC_DIR = '/game-assets/map-objects/decor';

/** Decor with bespoke Pixi logic (glow, modals, animations) — individual files, not atlas. */
export const DECOR_INTERACTIVE_DIR = '/game-assets/map-objects/decor-interactive';

export const DECOR_ATLAS_JSON_PATH = '/game-assets/map-objects/decor-atlas.json';

/** Types stored in decor-interactive/ and loaded outside the atlas. */
export const DECOR_INTERACTIVE_TYPES = new Set<string>([
  'decor_lighthouse',
  'decor_lighthouse_beacon',
  'decor_monument_cat_winston_churchill',
]);

export function isDecorInteractiveType(type: string): boolean {
  return DECOR_INTERACTIVE_TYPES.has(type);
}

export function getDecorImagePath(type: string): string {
  const dir = isDecorInteractiveType(type) ? DECOR_INTERACTIVE_DIR : DECOR_STATIC_DIR;
  return `${dir}/${type}.webp`;
}
